import { Box } from '@chakra-ui/react';
import React from 'react';
import PoojaBookingTable from './components/PoojaBookingTable';

export default function PoojaBookingManagement() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <PoojaBookingTable />
    </Box>
  );
}
